import { Subject } from "rxjs";
import { FilterNGraphConfig } from "./FilterNGraphConfig";

export class FilterNGraphModel {
    config: FilterNGraphConfig;
    thresholdSubject: Subject<boolean>; //threshold rendering
    unitSubject: Subject<Array<string>>; //graph unit changes
    dataSubject: Subject<any>; //refresh graph data
    updateConfig: Subject<FilterNGraphConfig>; //configuration changes

    constructor(title: string, selectedTagsUid: Array<string>){
        this.config = new FilterNGraphConfig(title, selectedTagsUid);
        this.thresholdSubject = new Subject<boolean>();
        this.unitSubject = new Subject<Array<string>>();
        this.dataSubject = new Subject<any>();
        this.updateConfig = new Subject<FilterNGraphConfig>();
    }
}